var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"iconContainer"},[_c('InfoIcon',{staticClass:"infoIcon"})],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h3',[_vm._v(" Désolé,"),_c('br'),_vm._v(" vous ne remplissez pas les critères d'éligibilité pour bénéficier des aides. ")])
}]

export { render, staticRenderFns }